import React, { useEffect, useState } from "react";
import Footer from "../components/common/Footer";
import NavBar from "../components/common/NavBar";
import TopImage from "../components/common/TopImage";

function FeesPage(props) {
  const [feesData, setFeesData] = useState({
    mandatoryFees: [],
    annualFees: [],
    otherCharges: []
  });

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/feesData.json`)
      .then((res) => res.json())
      .then((data) => setFeesData(data))
      .catch((err) => console.error("Error loading fees data:", err));
  }, []);

  const tableHeaders = { sno: "S.No.", class: "Class", annualFees: "Annual Fees" };

  return (
    <div>
      <NavBar />
      <TopImage text="Fees" />
      <div className="flex flex-col mx-28 max-md:mx-5 mt-20 items-start text-2xl  tracking-wide text-black ">
        <div className="max-md:max-w-full font-bold">Mandatory Fees</div>
        <div className="flex gap-5 justify-between pr-5 mt-4 max-w-full text-base tracking-wide leading-6 w-[648px] max-md:flex-wrap">
          <div>
            {feesData.mandatoryFees.map((fee, index) => (
              <p key={index} className="mb-1">{fee.item}:</p>
            ))}
          </div>
          <div>
            {feesData.mandatoryFees.map((fee, index) => (
              <p key={index} className="mb-1">{fee.amount}</p>
            ))}
          </div>
        </div>
      </div>
      <div className="shadow-sm mt-10 bg-white rounded-xl max-md:max-w-full overflow-hidden">
        <div className="ml-28 mb-10 text-2xl tracking-wide text-black  max-md:ml-4">
          The Annual fees of the school for different grades has been mentioned
          below in the table.
        </div>
        <div></div>
        <table className="mx-auto mb-10 w-3/4 shadow-md table-fixed rounded-2xl border-solid border-zinc-200 max-md:mx-auto max-md:w-11/12">
          <thead>
            {Object.keys(tableHeaders).map((key, index) => (
              <th
                key={index}
                className={`text-zinc-800 text-left font-bold text-l tracking-wide bg-blue-100 p-3 border-b-neutral-200 border-b border-solid`}
              >
                {tableHeaders[key]}
              </th>
            ))}
          </thead>
          <tbody>
            {feesData.annualFees.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td className={`justify-center px-3 py-4 capitalize border-b border-solid bg-zinc-50 border-b-zinc-200`}>
                  {row.sno}
                </td>
                <td className={`justify-center px-3 py-4 capitalize border-b border-solid bg-zinc-50 border-b-zinc-200`}>
                  {row.class}
                </td>
                <td className={`justify-center px-3 py-4 capitalize border-b border-solid bg-zinc-50 border-b-zinc-200`}>
                  {row.annualFees}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex flex-col mx-28 max-md:mx-5 mb-20 items-start text-2xl  tracking-wide text-black ">
        <div className="self-stretch mt-8 w-full max-md:max-w-full font-bold">
          Other Charges
        </div>
        <div className="self-stretch mt-4 w-full text-base tracking-wide leading-6 max-md:max-w-full">
          {feesData.otherCharges.map((charge, index) => (
            <React.Fragment key={index}>
              {charge}
              {index < feesData.otherCharges.length - 1 && <br />}
            </React.Fragment>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FeesPage;
